import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi.ts'
import { checkUsageAgent } from 'features/ItemUsage/actions/checkUsageAgent.tsx'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath.ts'

export const checkUsage = async (id: number, action: 'disable' | 'delete') => {
  const { data } = await AiCallingApi.getAgentUsage(id)
  return checkUsageAgent({
    data,
    action,
    getLink: (inbox) =>
      inbox.source === 'workflow'
        ? InboxesPath.inboxSmartCallFlow(inbox.team_id)
        : InboxesPath.inboxCallingV1(inbox.team_id),
  })
}
